<footer>
  <div class="container p-0">
    <div class="row m-0">
      <div class="col-md-3">
        <h4 class="title">{{ "General" | translate }}</h4>
        <ul>
          <li routerLink="/about">{{ "About Bogo" | translate }}</li>
          <!-- <li routerLink="/contact-us">{{'Contact us'|translate}}</li> -->
          <li routerLink="/faqs">{{ "FAQs" | translate }}</li>
          <li routerLink="/terms">{{ "Terms and conditions" | translate }}</li>
        </ul>
      </div>

      <div class="col-md-3">
        <h4 class="title">{{ "Contact" | translate }}</h4>
        <ul>
          <!-- <li>{{'Stores Location'|translate}}</li> -->
          <li routerLink="/login">{{ "User Login" | translate }}</li>
          <!-- <li routerLink="/forgot-password">{{'Forgot your password'|translate}}</li> -->
          <!-- <li>{{'Events'|translate}}</li> -->
        </ul>
      </div>

      <div class="col-md-3">
        <h4 class="title">{{ "Follow us" | translate }}</h4>
        <ul>
          <li>
            <a href="https://www.facebook.com/BogoPlus/" target="_blank">
              {{ "Facebook" | translate }}
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/bogoplus/" target="_blank">
              {{ "Instagram" | translate }}
            </a>
          </li>
          <!-- <li>
            <a href="https://twitter.com/bogo_plus" target="_blank">
              {{'Twitter'|translate}}
            </a>
          </li> -->
        </ul>
      </div>

      <div class="col-md-3">
        <h4 class="title">{{ "Get the App" | translate }}</h4>
        <ul>
          <li>
            <a
              href="https://apps.apple.com/eg/app/bogo-plus/id1537390208"
              target="_blank"
            >
              <img src="assets/imgs/app_store.png" class="w-50" />
            </a>
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.bit68.bogoplus&hl=en&gl=US"
              target="_blank"
            >
              <img src="assets/imgs/google_play.png" class="w-50" />
            </a>
          </li>
          <li>
            <a
              href="https://appgallery.huawei.com/#/app/C103627921"
              target="_blank"
            >
              <img src="assets/imgs/AppGallery.png" class="w-50" />
            </a>
          </li>
        </ul>
      </div>
    </div>

    <h5 class="text-center pt-4" fs12>
      {{ "Copyright © 2020 Bogo Plus Egypt - All rights reserved" | translate }}
    </h5>
  </div>
</footer>
